export enum EConstantElementType {
    BaseCabinet = 1,
    WallCabinet = 2,
    HighCabinet = 3,
    Global = 4
}